import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtService } from '@/services/jwt.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {

  permissoes: any[] = [];

  constructor(
    private router: Router,
    private http: HttpClient,
    private jwtService: JwtService,
  ) { }
  async canActivate() {
    const token = localStorage.getItem(environment.sessionKey);
    if (!token){
      this.router.navigate(['/auth/login']);
      return false;
    }

    if (!this.jwtService.isTokenExpired(token)) {
      return true;
    }

    const isRefreshSuccess = await this.refreshingTokens(token);

    if (!isRefreshSuccess) {
      this.router.navigate(['/auth/login']);
    }

    return isRefreshSuccess;
  }

  private async refreshingTokens(token: string | null): Promise<boolean> {
    const refreshToken: string | null = localStorage.getItem('refreshToken');

    if (!token || !refreshToken) {
      return false;
    }

    const tokenModel = JSON.stringify({
      accessToken: token,
      refreshToken: refreshToken,
    });

    let isRefreshSuccess: boolean;
    try {
      const response = await lastValueFrom(
        this.http.post(environment.baseURL + '/refresh-token', tokenModel),
      );
      const newToken = (<any>response).accessToken;
      const newRefreshToken = (<any>response).refreshToken;
      localStorage.setItem('accessToken', newToken);
      localStorage.setItem('refreshToken', newRefreshToken);
      isRefreshSuccess = true;
    } catch (ex) {
      isRefreshSuccess = false;
    }
    return isRefreshSuccess;
  }
}
